<div class="OlivorCms">
      <section class="cmsBanner farmbg">
            <div class="container">
                  <div class="col-md-12">
                        <h2>The Farm Store</h2>
                  </div>
            </div>
      </section>
      <section class="olivorOurStory">
            <div class="container">
                  <div class="row" fxLayout="row wrap" fxLayoutAlign="start center">
                        <div class="col-lg-6">
                              <div class="imgObj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/2020-08-20_14-06-43_1597921613.png?width=800&dpr=1.5" alt="">
                              </div>
                        </div>
                        <div class="col-lg-6 olivorOurStoryInfo">
                              <h2>WHERE TO FIND US!</h2>
                              <p>OUR FARM STORE LOCATED AT 341 SYDNEY WASHER ROAD DOVER, FLORIDA 33527 OPEN TUESDAY 10-5, THURSDAY 1-5, FRIDAY AND SATURDAY 10-5. CLOSED SUNDAY AND MONDAY.</p>
                              <button class="bgDarkBrown mt-40">Learn More</button>
                        </div>
                        
                  </div>
            </div>
      </section>
      <section class="oliverStoreGallery">
            <div class="container">
                  <div class="row">
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/farm-store_1597921059.jpg?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/img951001_1597921058.jpg?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Screenshot_28_1597921202.png?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Screenshot_30_1597921429.png?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Screenshot_32_1597921429.png?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="imgOj">
                                    <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Screenshot_31_1597921429.png?width=2400&optimize=medium" alt="">
                              </div>
                        </div>
                  </div>
            </div>
      </section>
</div>